<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-container grid-list-xl>
            <v-layout wrap>
                <v-flex xs12>
                    <v-switch :label="$t('Habilitado')" v-model="item.enable" class="my-0 py-0" />
                    <v-switch :label="$t('Em Manutenção')" v-model="item.inMaintenance" class="my-0 py-0" />
                    <v-switch :label="$t('Passou no teste')" v-model="item.approved" class="my-0 py-0" disabled/>
                </v-flex>
                <v-flex xs6 mb-6>
                    <v-text-field :label="$t('Número de serie')" v-model="item.serialNumber" :rules="[rules.required]" />
                </v-flex>
                <v-flex xs6 mb-6>
                    <v-text-field :label="$t('Tipo')" v-model="item.type" />
                </v-flex>
                <v-flex xs6 mb-6>
                    <v-text-field :label="$t('Modelo')" v-model="item.model" />
                </v-flex>

                <v-flex xs12>
                    <FactorySelect :value="item.factory" @change="item.factory = $event" />
                </v-flex>

                <v-flex xs12 md12 sm12>
                    <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

import FactorySelect from "@/components/shared/FactorySelect";

export default {
    components: { FactorySelect },

    directives: { mask },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            itemClean: {
                type: null,
                model: "",
                serialNumber: "",
                factory: null,
                approved: false,
                inMaintenance: false,
                enable: true,
            },
            item: { ...this.itemClean },
        };
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                this.$nextTick(() => {
                    if (newVal == null) {
                        this.item = { ...this.itemClean };
                    } else {
                        this.item = { ...newVal };
                    }
                });
            },
        },
    },

    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
    },

    mounted() {
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    },
};
</script>